import { render, staticRenderFns } from "./Projectview.vue?vue&type=template&id=2c3b5aaa&scoped=true&"
import script from "./Projectview.vue?vue&type=script&lang=js&"
export * from "./Projectview.vue?vue&type=script&lang=js&"
import style0 from "./Projectview.vue?vue&type=style&index=0&id=2c3b5aaa&scoped=true&lang=css&"
import style1 from "./Projectview.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3b5aaa",
  null
  
)

export default component.exports